import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, watch } from 'vue';
import CurrencyInfoTableCell from './CurrencyInfoTableCell.vue';
import { AuthorityType, Wallet } from 'ah-api-gateways';
import AddMoneyModal from './AddMoneyModal.vue';
import { WalletsPaginatedQuery } from 'ah-api-gateways';
import { from } from 'rxjs';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { useManagedListing, defineUseManagedListingProps, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useWalletState } from '..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { FundsInTransitIcon } from 'ah-common-lib/src/icons/components';
import TextBlockWithOverflowTooltip from 'ah-common-lib/src/text/TextBlockWithOverflowTooltip.vue';

interface WalletEmits extends UseManagedListingEmits<Wallet> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletListing',
  props: {
  walletId: {
    type: String,
  },
  narrow: {
    type: [Boolean, String],
    default: false,
  },
  hideHeaders: {
    type: [Boolean, String],
    default: false,
  },
  hidePagination: {
    type: [Boolean, String],
    default: false,
  },
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({
      tableFields: [
        {
          header: 'Currency',
          key: 'currency',
        },
        {
          header: 'In Transit',
          key: 'inTransit',
        },
        {
          header: 'Balance',
          key: 'balance',
        },
        {
          header: 'Fee Warning',
          key: 'feeWarning',
          colStyle: { width: '2em' },
          class: 'fee-warning',
        },
      ],
    }),
  },
  ...defineUseManagedListingProps<Wallet>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const requestManager = useRequestManager({
  exposeToParent: ['loadFeesInfo'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadFeesInfo') {
      loadFees();
    }
  },
});

const onBehalfOfClient = useOnBehalfOf();

const walletState = useWalletState();

const withOutstandingFees = computed(() => feesInfo.value && feesInfo.value.debtCumulative > 0);



const canSeeFundingDetails = computed(() =>
  walletState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_FUNDING_DETAILS)
);

const feesInfo = computed(() => {
  return isPartnerWalletListing.value
    ? walletState.store.useWalletsStore().getPartnerFeesInfo()
    : walletState.store.useWalletsStore().getClientFeesInfo(ownerId.value!);
});

const isPartnerWalletListing = computed(
  () => !onBehalfOfClient.value && !walletState.store.useAuthStore().isClientUser
);

const ownerId = computed(() => {
  if (onBehalfOfClient.value) {
    return onBehalfOfClient.value.id;
  }
  return (
    walletState.store.useAuthStore().loggedInIdentity?.client?.id ||
    walletState.store.useAuthStore().loggedInIdentity?.partner?.id
  );
});

const managedListing = useManagedListing<Wallet>({
  loadDataRequest(query?: WalletsPaginatedQuery) {
    return from(
      walletState.store.useWalletsStore().listWallets({
        query,
        owner: {
          isPartner: isPartnerWalletListing.value,
          id: ownerId.value,
        },
      })
    );
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: requestManager.manager,
});

function loadFees() {
  if (walletState.store.useAuthStore().isLoggedIn) {
    requestManager.manager.newPromise(
      'loadFeesInfo',
      isPartnerWalletListing.value
        ? walletState.store.useWalletsStore().loadPartnerFeesInfo({ force: false })
        : walletState.store.useWalletsStore().loadClientFeesInfo({ force: false, clientId: ownerId.value! })
    );
  }
}

watch(ownerId, loadFees);

function rowClass(item: Wallet | null) {
  if (item && feesInfo.value && walletState.mediaQuery.is('smDown'))
    return withOutstandingFees.value && item.currency === feesInfo.value.debtCurrency ? 'highlight-left' : '';
  return '';
}

expose({ loadData: () => managedListing.loadData() });

return { __sfc: true,props, requestManager, onBehalfOfClient, walletState, withOutstandingFees, emit, canSeeFundingDetails, feesInfo, isPartnerWalletListing, ownerId, managedListing, loadFees, rowClass, CurrencyInfoTableCell, AddMoneyModal, formatCurrencyValue, FundsInTransitIcon, TextBlockWithOverflowTooltip }
}

})